// ======================================================================
// File: src/modules/ppe/fms/services/fmsService.js
// Module: PPE → FMS
// Purpose: API communication layer for Followup Management System
// ======================================================================

import axiosClient from "../../../../api/axiosClient";

// ----------------------------------------------------------------------
// CORRECT BASE URL (matches backend exactly)
// ----------------------------------------------------------------------
const BASE_URL = "/api/ppe/fms";

const fmsService = {

  // -------------------------------
  // Followup CRUD
  // -------------------------------

getFollowupList: async (
  page = 1,
  pageSize = 20,
  status = "",
  search = ""
) => {

  const res = await axiosClient.get(
    `${BASE_URL}/list`,
    {
      params: {
        page,
        page_size: pageSize,
        status,
        search
      }
    }
  );

  return res.data;
},
  getFollowupById: async (id) => {
    const res = await axiosClient.get(`${BASE_URL}/${id}`);
    return res.data;
  },

  createFollowup: async (payload) => {
    const res = await axiosClient.post(`${BASE_URL}/create`, payload);
    return res.data;
  },

  updateFollowup: async (id, payload) => {
    const res = await axiosClient.put(`${BASE_URL}/${id}`, payload);
    return res.data;
  },

  changeStatus: async (id, payload) => {
    const res = await axiosClient.post(`${BASE_URL}/${id}/status`, payload);
    return res.data;
  },

  executeAction: async (id, payload) => {
    const res = await axiosClient.post(`${BASE_URL}/${id}/execute`, payload);
    return res.data;
  },

  // -------------------------------
  // Rules
  // -------------------------------

  createRule: async (payload) => {
    const res = await axiosClient.post(`${BASE_URL}/rules/create`, payload);
    return res.data;
  },

  
    createNextFollowup: async (id) => {
    const res = await axiosClient.post(`${BASE_URL}/${id}/create-next`);
    return res.data;
  },

  // -------------------------------
  // Scheduler
  // -------------------------------

  addSchedulerJob: async (payload) => {
    const res = await axiosClient.post(`${BASE_URL}/scheduler/add`, payload);
    return res.data;
  }

};

export default fmsService;
